export default __webpack_public_path__ + "static/media/edit-color.9328bdf9.svg";